import React, { useState, useEffect } from "react";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { useLocation } from "react-router";
import { XMarkIcon } from '@heroicons/react/24/outline';
import Nav from './Nav';
import Illu from './img/illu-2.png';

export default function Jugement() {
  const [question0, setQuestion0] = useState(true);
  const [question1, setQuestion1] = useState(false);
  const [resultat1, setResultat1] = useState(false);
  const [question2, setQuestion2] = useState(false);
  const [resultat2, setResultat2] = useState(false);
  const [question3, setQuestion3] = useState(false);
  const [resultat3, setResultat3] = useState(false);
  const [coupable, setCoupable] = useState(false);

  // genre / âge
  const [genre, setGenre] = useState(null);
  const [age, setAge] = useState(null);

  // ressources
  const [openPoeme, setOpenPoeme] = useState(false);
  const [openDoc, setOpenDoc] = useState(false);
  const [openExperte1, setOpenExperte1] = useState(false);
  const [openExperte2, setOpenExperte2] = useState(false);

  const location = useLocation();
  const URL = `https://api.airtable.com/v0/appdSwprfbQowxVAW/votes`;

  // Bouton sélectionnable réutilisable
  function SelectButton({ label, value, selected, onSelect }) {
    return (
      <button
        onClick={() => onSelect(value)}
        className={`px-6 py-2.5 text-sm font-semibold rounded-lg border-2 
          ${selected === value
            ? "bg-black text-white border-black"
            : "bg-transparent text-black border-black hover:bg-black hover:text-white"
          }`}
      >
        {label}
      </button>
    );
  }

  /*************** ENREGISTREMENTS AIRTABLE ****************/

  function rep0(reponse) {
    console.log("reponse 0", reponse);
    setQuestion0(false);
          setQuestion1(true);
  }

  function rep1(reponse) {
    console.log("reponse 1", reponse);
    if (reponse === "oui") {
      setQuestion1(false);
      setQuestion2(true);
    } else if (reponse === "non") {
      const enregistrementVote = async () => {
        try {
          const response = await fetch(URL, {
            method: "POST",
            headers: {
              Authorization: "Bearer patH8zEHhdYVAXIJ2.bff641616bc85ab323b0336751bb323a8b9f0f2f3057c7153624930c73eac9ba",
              Accept: "application/json",
              "content-type": "application/json",
            },
            body: JSON.stringify({
              fields: {
                jugement: "non coupable",
                url: location.pathname,
                "genre": genre,
                            "age": age,
              },
            }),
          });
          const resp = await response.json();
          console.log("res vote", resp);
          if (resp) {
            setQuestion1(false);
            setResultat1(true);
          }
        } catch (e) {
          console.log(e);
        }
      };
      enregistrementVote();
    }
  }

  function rep2(reponse) {
    console.log("reponse 2", reponse);
    if (reponse === "non") {
      setQuestion2(false);
      setQuestion3(true);
    } else if (reponse === "oui") {
      const enregistrementVote = async () => {
        try {
          const response = await fetch(URL, {
            method: "POST",
            headers: {
              Authorization: "Bearer patH8zEHhdYVAXIJ2.bff641616bc85ab323b0336751bb323a8b9f0f2f3057c7153624930c73eac9ba",
              Accept: "application/json",
              "content-type": "application/json",
            },
            body: JSON.stringify({
              fields: {
                jugement: "coupable excuse verité",
                url: location.pathname,
                "genre": genre,
                            "age": age,
              },
            }),
          });
          const resp = await response.json();
          console.log("res vote", resp);
          if (resp) {
            setQuestion2(false);
            setResultat2(true);
          }
        } catch (e) {
          console.log(e);
        }
      };
      enregistrementVote();
    }
  }

  function rep3(reponse) {
    console.log("reponse 3", reponse);
    if (reponse === "non") {
      const enregistrementVote = async () => {
        try {
          const response = await fetch(URL, {
            method: "POST",
            headers: {
              Authorization: "Bearer patH8zEHhdYVAXIJ2.bff641616bc85ab323b0336751bb323a8b9f0f2f3057c7153624930c73eac9ba",
              Accept: "application/json",
              "content-type": "application/json",
            },
            body: JSON.stringify({
              fields: {
                jugement: "coupable et condamnée",
                url: location.pathname,
                "genre": genre,
                            "age": age,
              },
            }),
          });
          const resp = await response.json();
          console.log("res vote", resp);
          if (resp) {
            setQuestion3(false);
            setCoupable(true);
          }
        } catch (e) {
          console.log(e);
        }
      };
      enregistrementVote();
    } else if (reponse === "oui") {
      const enregistrementVote = async () => {
        try {
          const response = await fetch(URL, {
            method: "POST",
            headers: {
              Authorization: "Bearer patH8zEHhdYVAXIJ2.bff641616bc85ab323b0336751bb323a8b9f0f2f3057c7153624930c73eac9ba",
              Accept: "application/json",
              "content-type": "application/json",
            },
            body: JSON.stringify({
              fields: {
                jugement: "coupable excuse bonne foi",
                url: location.pathname,
                "genre": genre,
                            "age": age,
              },
            }),
          });
          const resp = await response.json();
          console.log("res vote", resp);
          if (resp) {
            setQuestion3(false);
            setResultat3(true);
          }
        } catch (e) {
          console.log(e);
        }
      };
      enregistrementVote();
    }
  }

  // Quand genre + âge sont remplis sur question 0 → on enregistre et on passe à la question 1
    useEffect(() => {
  // Si on est sur la question 0 et que genre + age sont remplis
  if (question0 && genre && age) {
    setQuestion0(false);
        setQuestion1(true);
  }
}, [genre, age]);


  return (
    <>
      <div className="bg-[url('img/back-proces.png')] bg-top bg-cover">
        <Nav />

        <div className="relative isolate px-6 pt-14 lg:px-8">
          <div className="mx-auto max-w-7xl py-32">
            <div className="text-left">
              <h1 className="text-balance text-[80px] leading-[5.5rem] font-semibold tracking-tight text-white  max-w-[80%] ">
                Devenez juré.e
              </h1>
              <p className='text-white'>
                Votez pour déterminer si Madame Gaber doit ou non être condamnée pour diffamation.
              </p>

              {/* explication */}
              <div className='mt-10'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-3 text-white items-center'>
                  <div className='items-center'>
                    <h2 className='ss-titre'>Qu’est-ce que <br />la diffamation ?</h2>
                    <p className='text-[18px] mt-5 font-normal'>
                      La diffamation est une infraction pénale qui sanctionne le fait de porter atteinte à l’honneur ou à la réputation d’une personne par des propos publics la concernant.
                    </p>
                  </div>
                  <div className='text-center'>
                    <img className='w-auto mx-auto max-h-[340px]' src={Illu} alt="notre proces" />
                  </div>
                </div>
              </div>

              {/* content */}
              <div className='mt-12'>
                <p className='text-white font-normal text-[28px]'>
                  L’auteur.ice présumé.e d’une diffamation peut invoquer, pour éviter d’être condamné.e, 2 types d’excuses possibles :
                </p>
              </div>

              {/* cards excuses */}
              <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 mt-10 sm:w-4/5 sm:mx-auto'>
                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-52 sm:mb-16 '>
                  <p className='text-[60px] font-bold sm:mb-16'>L’excuse de vérité</p>
                  <p className='text-[20px] font-normal sm:mt-[80px] mt-[30px]'>
                    Si les faits allégués dans la déclaration diffamatoire sont vrais, l’auteur.ice peut invoquer ce moyen de défense. En l’espèce, cette excuse peut être invoquée si vous estimez que le poème « L’Oaristys » de André Chénier participe bel et bien à la culture du viol.
                  </p>
                </div>
                <div className='p-6 rounded-lg bg-[#511277] flex flex-col items-stretch justify-between text-white min-h-52 sm:mt-16'>
                  <p className='text-[60px] font-bold sm:mb-16'>L'excuse de bonne foi</p>
                  <p className='text-[20px] font-normal  sm:mt-[80px] mt-[30px]'>
                    Invoquer cette excuse suppose la réunion de 4 conditions : l’absence d’animosité personnelle, la mesure dans l’expression, que les propos reposent sur une base factuelle solide et qu’ils s’inscrivent dans un débat d’intérêt général.
                  </p>
                </div>
              </div>

              {/* ressources */}
              <div className='mt-12'>
                <p className='text-white font-normal text-[28px]'> Quelques ressources pour vous aider à rendre votre verdict</p>
                <div className='flex gap-6 justify-start mt-6 flex-wrap'>
                  <button
                    onClick={() => setOpenPoeme(true)}
                    className='border-2 border-white bg-transparent rounded-lg text-white px-6 py-2.5 text-sm font-semibold  hover:bg-white hover:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Lire le poème
                  </button>
                  <button
                    onClick={() => setOpenDoc(true)}
                    className='border-2 border-white bg-transparent rounded-lg text-white px-6 py-2.5 text-sm font-semibold  hover:bg-white hover:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Document à l’adresse des juré.es
                  </button>
                  <button
                    onClick={() => setOpenExperte1(true)}
                    className='border-2 border-white bg-transparent rounded-lg text-white px-6 py-2.5 text-sm font-semibold  hover:bg-white hover:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Expertise de Hélène Merlin-Kajman
                  </button>
                  <button
                    onClick={() => setOpenExperte2(true)}
                    className='border-2 border-white bg-transparent rounded-lg text-white px-6 py-2.5 text-sm font-semibold  hover:bg-white hover:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Expertise de Laure Murat
                  </button>
                </div>
              </div>

              {/* intro questions */}
              <div className='mt-12'>
                <p className='ss-titre'>
                  Pour déterminer si Madame Gaber est coupable de diffamation, vous devez répondre à 3 questions
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* QUESTIONS */}
        <div className="relative ">

          {/* Question 0 : genre + âge */}
          {question0 === true && (
            <div className="sticky top-0 h-screen flex flex-col items-left w-content justify-center bg-[#CB40A6] p-6">
              <div className='mx-auto max-w-7xl py-32'>
                <span className="rounded-full bg-transparent px-3 py-2 text-lg font-medium text-black ring-2 ring-inset ring-black mb-6">
                  Tout d'abord
                </span>

                <p className="ss-titre text-black mt-6">Quel est votre genre ?</p>
                <div className='flex gap-6 justify-start mt-6 flex-wrap'>
                  <SelectButton label="Homme" value="homme" selected={genre} onSelect={setGenre} />
                  <SelectButton label="Femme" value="femme" selected={genre} onSelect={setGenre} />
                  <SelectButton label="Non-binaire" value="non-binaire" selected={genre} onSelect={setGenre} />
                  <SelectButton label="Je ne préfère pas répondre" value="pas-reponse" selected={genre} onSelect={setGenre} />
                </div>

                <div className='mx-auto max-w-7xl mt-10'>
                  <p className="ss-titre text-black mt-6">Quel est votre âge ?</p>
                  <div className='flex gap-6 flex-wrap justify-start mt-6 '>
<SelectButton label="Moins de 18 ans" value="-18" selected={age} onSelect={setAge} />
                    <SelectButton label="18–24 ans" value="18-24" selected={age} onSelect={setAge} />
                    <SelectButton label="25–34 ans" value="25-34" selected={age} onSelect={setAge} />
                    <SelectButton label="35–44 ans" value="35-44" selected={age} onSelect={setAge} />
                    <SelectButton label="45–54 ans" value="45-54" selected={age} onSelect={setAge} />
                    <SelectButton label="55 ans et +" value="55+" selected={age} onSelect={setAge} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Question 1 */}
          {question1 === true && (
            <div className="sticky top-0 h-screen flex flex-col items-left w-content justify-center bg-[#CB40A6] p-6">
              <div className='mx-auto max-w-7xl py-32'>
                <span className="rounded-full bg-transparent px-3 py-2 text-lg font-medium text-black ring-2 ring-inset ring-black mb-6">
                  Question 1
                </span>
                <p className="ss-titre text-black mt-6">
                  Jugez-vous que Madame Gaber, en publiant le hashtag <i>#cheniercultureduviol</i>, a porté atteinte à l’honneur et à la considération de Monsieur Chénier ?
                </p>
                <div className='flex gap-6 justify-start mt-6'>
                  <button
                    onClick={() => rep1("oui")}
                    className='border-2 border-black bg-transparent rounded-lg text-black px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Oui
                  </button>
                  <button
                    onClick={() => rep1("non")}
                    className='border-2 border-black bg-transparent rounded-lg text-black px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Non
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Question 2 */}
          {question2 === true && (
            <div className="sticky top-0 h-screen flex flex-col items-left w-content justify-center bg-[#D9D9D9] p-6">
              <div className='mx-auto max-w-7xl py-32'>
                <p className="mb-10 sm:text-[20px]">
                  Vous reconnaissez donc Madame Gaber coupable de diffamation, néanmoins, en droit français il existe ce que l’on appelle des excuses de diffamation pour éviter la condamnation. La première est l’excuse de vérité. Elle implique de répondre à la question suivante :
                </p>
                <span className="rounded-full bg-transparent px-3 py-2 text-lg font-medium text-black ring-2 ring-inset ring-black mb-6">
                  Question 2
                </span>
                <p className="ss-titre text-black mt-6">
                  Jugez-vous que le poème de Monsieur Chénier participe à la perpétuation de la culture du viol ?
                </p>
                <div className='flex gap-6 justify-start mt-6'>
                  <button
                    onClick={() => rep2("oui")}
                    className='border-2 border-black bg-transparent rounded-lg text-black px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Oui
                  </button>
                  <button
                    onClick={() => rep2("non")}
                    className='border-2 border-black bg-transparent rounded-lg text-black px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Non
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Question 3 */}
          {question3 === true && (
            <div className="sticky top-0 h-screen flex flex-col items-left w-content justify-center bg-[#511277] p-6">
              <div className='mx-auto max-w-7xl py-32'>
                <p className="mb-10 text-white sm:text-[20px]">
                  Vous estimez que l&apos;excuse de vérité ne s&apos;applique pas. Il y a toutefois une seconde excuse possible : l’excuse de bonne foi. Elle implique de répondre à la question suivante :
                </p>
                <span className="rounded-full bg-transparent px-3 py-2 text-lg font-medium text-white ring-2 ring-inset ring-white mb-6">
                  Question 3
                </span>
                <p className="ss-titre text-white mt-6">
                  Jugez-vous que Madame Gaber, en publiant le hashtag <i>#cheniercultureduviol</i>, a soulevé une question d’intérêt général ET a été mesurée dans son expression ?
                </p>
                <div className='flex gap-6 justify-start mt-6'>
                  <button
                    onClick={() => rep3("oui")}
                    className='border-2 border-white bg-transparent rounded-lg text-white px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Oui
                  </button>
                  <button
                    onClick={() => rep3("non")}
                    className='border-2 border-white bg-transparent rounded-lg text-white px-6 py-2.5 text-sm font-semibold  hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  >
                    Non
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Résultat 1 */}
          {resultat1 === true && (
            <div className="sticky top-0 h-screen flex flex-col items-center w-content justify-center bg-transparent  p-6">
              <div className='mx-auto max-w-2xl py-32'>
                <p className="ss-titre mb-8">
                  Vous déclarez Madame Gaber
                </p>
                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-32 sm:mb-8'>
                  <p className='text-[60px] font-bold mb-4'>Non coupable de diffamation</p>
                </div>
                <p className="text-white mt-4">
                  Les résultats de votre représentation<br />
                  <b>Bordeaux le 24 janvier 2025</b>
                </p>
                <p className="text-white">En cours de calcul</p>
              </div>
            </div>
          )}

          {/* Résultat 2 */}
          {resultat2 === true && (
            <div className="sticky top-0 h-screen flex flex-col items-center w-content justify-center bg-transparent p-6">
              <div className='mx-auto max-w-2xl py-32'>
                <p className="ss-titre mb-8">
                  Vous déclarez Madame Gaber
                </p>
                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-32 sm:mb-8'>
                  <p className='text-[38px] sm:text-[60px] font-bold mb-4'>
                    Coupable mais échappant à la condamnation
                  </p>
                  <p className='text-[20px] font-normal mt-[20px]'>
                    Au titre de l&apos;excuse de vérité
                  </p>
                </div>
                <p className="text-white mt-4">
                  Les résultats de votre représentation<br />
                  <b>Bordeaux le 24 janvier 2025</b>
                </p>
                <p className="text-white">En cours de calcul</p>
              </div>
            </div>
          )}

          {/* Résultat 3 */}
          {resultat3 === true && (
            <div className="sticky top-0 h-screen flex flex-col items-center w-content justify-center bg-transparent p-6">
              <div className='mx-auto max-w-2xl py-32'>
                <p className="ss-titre mb-8">
                  Vous déclarez Madame Gaber
                </p>
                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-32 sm:mb-8'>
                  <p className='text-[38px] sm:text-[60px] font-bold mb-4'>
                    Coupable mais échappant à la condamnation
                  </p>
                  <p className='text-[20px] font-normal mt-[20px]'>
                    Au titre de l’excuse de bonne foi
                  </p>
                </div>
                <p className="text-white mt-4">
                  Les résultats de votre représentation<br />
                  <b>Bordeaux le 24 janvier 2025</b>
                </p>
                <p className="text-white">En cours de calcul</p>
              </div>
            </div>
          )}

          {/* Coupable et condamnée */}
          {coupable === true && (
            <div className="sticky top-0 h-screen flex flex-col items-center w-content justify-center bg-transparent p-6">
              <div className='mx-auto max-w-2xl py-32'>
                <p className="ss-titre mb-8">
                  Vous déclarez Madame Gaber
                </p>
                <div className='p-6 rounded-lg bg-[#b20b7c] flex flex-col items-stretch justify-between text-white min-h-32 sm:mb-8'>
                  <p className='text-[38px] sm:text-[60px] font-bold mb-4'>
                    Coupable de diffamation et condamnée
                  </p>
                </div>
                <p className="text-white mt-4">
                  Les résultats de votre représentation<br />
                  <b>Bordeaux le 24 janvier 2025</b>
                </p>
                <p className="text-white">En cours de calcul</p>
              </div>
            </div>
          )}
        </div>
      </div>

            {/** POEME */}
            <Dialog open={openPoeme} onClose={setOpenPoeme} className="fixed inset-0 z-10 overflow-y-auto">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen ">
                    <div className="flex min-h-[90%] items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-y-auto rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <DialogTitle><h2 className="text-lg font-bold mb-5">«Texte du poème L’Oaristys» d’André Chénier</h2></DialogTitle>
                            <div className="overflow-y-auto" style={{ maxHeight: "85vh"}}>
                                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                    <button
                                        type="button"
                                        onClick={() => setOpenPoeme(false)}
                                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon aria-hidden="true" className="size-6" />
                                    </button>
                                </div>
                                
                                <p class="mt-5"><b>DAPHNIS (BERGER), NAÏS (BERGÈRE)</b></p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Hélène daigna suivre un berger ravisseur ;<br />
                                    Berger comme Pâris, j’embrasse mon Hélène.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> C’est trop s'enorgueillir d’une faveur si vaine.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Ah ! ces baisers si vains ne sont pas sans douceur.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Tiens, ma bouche essuyée en a perdu la trace.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Eh bien ! d’autres baisers en vont prendre la place.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Adresse ailleurs ces vœux dont l’ardeur me poursuit :<br />
                                    Va, respecte une vierge.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Imprudente bergère,<br />
                                    Ta jeunesse te flatte ; ah ! n’en sois point si fière :<br />
                                    Comme un songe insensible, elle s’évanouit.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Chaque âge a ses honneurs, et la saison dernière<br />
                                    Aux fleurs de l’oranger fait succéder son fruit.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Viens sous ces oliviers ; j’ai beaucoup à te dire.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Non ; déjà tes discours ont voulu me tenter.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Suis-moi sous ces ormeaux ; viens de grâce écouter<br />
                                    Les sons harmonieux que ma flûte respire :<br />
                                    J’ai fait pour toi des airs, je te les veux chanter ;<br />
                                    Déjà tout le vallon aime à les répéter.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Va, tes airs langoureux ne sauraient me séduire.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Eh quoi ! seule à Vénus penses-tu résister ?</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Je suis chère à Diane ; elle me favorise.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Vénus a des liens qu’aucun pouvoir ne brise.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Diane saura bien me les faire éviter.<br />
                                    Berger, retiens ta main… berger, crains ma colère.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Quoi ! tu veux fuir l’Amour ! l’Amour à qui jamais<br />
                                    Le cœur d’une beauté ne pourra se soustraire ?</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Oui, je veux le braver… Ah !… si je te suis chère…<br />
                                    Berger… retiens ta main… laisse mon voile en paix.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Toi-même, hélas ! bientôt livreras ces attraits<br />
                                    À quelque autre berger bien moins digne de plaire.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Beaucoup m’ont demandée, et leurs désirs confus<br />
                                    N’obtinrent, avant toi, qu’un refus pour salaire.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Et je ne dois comme eux attendre qu’un refus ?</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Hélas ! l’hymen aussi n’est qu’une loi de peine ;<br />
                                    Il n’apporte, dit-on, qu’ennuis et que douleurs.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> On ne te l’a dépeint que de fausses couleurs :<br />
                                    Les danses et les jeux, voilà ce qu’il amène.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Une femme est esclave.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Ah ! plutôt elle est reine.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Tremble près d’un époux et n’ose lui parler.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Eh ! devant qui ton sexe est-il fait pour trembler ?</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> À des travaux affreux Lucine nous condamne.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Il est bien doux alors d’être chère à Diane.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Quelle beauté survit à ces rudes combats ?</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Une mère y recueille une beauté nouvelle :<br />
                                    Des enfants adorés feront tous tes appas ;<br />
                                    Tu brilleras en eux d’une splendeur plus belle.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Mais, tes vœux écoutés, quel en serait le prix ?</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Tout : mes troupeaux, mes bois et ma belle prairie ;<br />
                                    Un jardin grand et riche, une maison jolie,<br />
                                    Un bercail spacieux pour tes chères brebis ;<br />
                                    Enfin, tu me diras ce qui pourra te plaire ;<br />
                                    Je jure de quitter tout pour te satisfaire :<br />
                                    Tout pour toi sera fait aussitôt qu’entrepris.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Mon père…</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Oh ! s’il n’est plus que lui qui te retienne,<br />
                                    Il approuvera tout dès qu’il saura mon nom.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Quelquefois il suffit que le nom seul prévienne :<br />
                                    Quel est ton nom ?</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Daphnis ; mon père est Palémon.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Il est vrai : ta famille est égale à la mienne.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Rien n’éloigne donc plus cette douce union.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Montre-les moi, ces bois qui seront mon partage.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Viens ; c’est à ces cyprès de leurs fleurs couronnés.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Restez, chères brebis, restez sous cet ombrage.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Taureaux, paissez en paix ; à celle qui m’engage<br />
                                    Je vais montrer les biens qui lui sont destinés.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Satyre, que fais-tu ? Quoi ! ta main ose encore…</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Eh ! laisse-moi toucher ces fruits délicieux…<br />
                                    Et ce jeune duvet…</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Berger… au nom des dieux…<br />
                                    Ah !… je tremble…</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Et pourquoi ? que crains-tu ? Je t’adore.<br />
                                    Viens.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Non ; arrête… Vois, cet humide gazon<br />
                                    Va souiller ma tunique, et je serais perdue ;<br />
                                    Mon père le verrait.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Sur la terre étendue<br />
                                    Saura te garantir cette épaisse toison.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Dieux ! quel est ton dessein ? Tu m’ôtes ma ceinture.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> C’est un don pour Vénus ; vois, son astre nous luit.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Attends… si quelqu’un vient. Ah ! dieux ! j’entends du bruit.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> C’est ce bois qui de joie et s’agite et murmure.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Tu déchires mon voile !… Où me cacher ? Hélas !<br />
                                    Me voilà nue ! où fuir !</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> À ton amant unie,<br />
                                    De plus riches habits couvriront tes appâts.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Tu promets maintenant, tu préviens mon envie,<br />
                                    Bientôt à mes regrets tu m’abandonneras.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Oh ! non ! jamais. Pourquoi, grands dieux ! ne puis-je pas<br />
                                    Te donner et mon sang, et mon âme, et ma vie ?</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Ah !… Daphnis ! je me meurs… <br />
                                    Apaise ton courroux,<br />
                                    Diane.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Que crains-tu ? L’amour sera pour nous.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> Ah ! méchant, qu’as-tu fait ?</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> J’ai signé ma promesse.</p>

                                <p class="mt-5"><b>NAÏS.<br /></b> J’entrai fille en ce bois et chère à ma déesse.</p>

                                <p class="mt-5"><b>DAPHNIS.<br /></b> Tu vas en sortir femme, et chère à ton époux.</p>

                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>

            {/** A l'attention des jurés */}
            <Dialog open={openDoc} onClose={setOpenDoc} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen ">
                    <div className="flex min-h-[90%] items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-y-auto rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <DialogTitle><h2 className="text-lg font-bold mb-5">Document à l’attention des juré.es</h2></DialogTitle>
                            <div className="overflow-y-auto"  style={{ maxHeight: "85vh"}}>
                                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                    <button
                                        type="button"
                                        onClick={() => setOpenDoc(false)}
                                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon aria-hidden="true" className="size-6" />
                                    </button>
                                </div>
                                <p className="text-sm">
                                Tout.e citoyen.ne français inscrit.e sur les listes électorales, peut être tiré.e au sort pour être juré.e devant la cour d'assises. 

                                <br/><br/>Vous venez d’être désigné.e pour siéger au procès en diffamation intenté par Monsieur André Chénier, poète, à Madame Salomé Gaber, enseignante en lettres. 

                                <br/><br/>Vous devez voter sur sa culpabilité selon votre intime conviction, et décider si vous jugez ses propos diffamatoires, et dans ce cas, si vous considérez qu’elle doit être condamnée - en effet, une personne coupable de diffamation peut échapper à la condamnation si elle bénéficie de l’excuse de vérité ou de bonne foi. 


                                <br/><br/>Pour que vous puissiez vous forger un avis éclairé, voici quelques éléments de présentation des enjeux de ce procès hors-norme.  

                                <br/><br/>Le tribunal a dû faire face à un fait inhabituel. L’affaire C/Gaber oppose en effet Salomé Gaber, jeune étudiante candidate au concours de l’agrégation autrice d’un hashtag devenu viral <i>#cheniercultureduviol</i>, à André Chénier (1762-1794), poète qui revient d’entre les morts pour défendre son honneur et son nom dans le cadre d’un procès en diffamation. 

                                <br/><br/>Il s’agit de plus d’un procès en diffamation expérimental. Bien que la diffamation relève du tribunal correctionnel, cette affaire est jugée par un jury populaire, sollicité du fait des enjeux de société et des questions d’intérêt général qu’elle soulève : les violences sexistes et sexuelles, mais aussi les notions de consentement, de culture du viol, de zone grise et de liberté d’expression et de création. 
                                
                                <br/><br/>Voici un bref rappel des faits : en 2017, Madame Gaber était candidate au concours de l’agrégation de lettres, dans lequel un poème d’André Chénier, “l’Oaristys”, était mis au programme. Le 3 novembre 2017, Madame Gaber a co-écrit une lettre ouverte au jury de l’agrégation de ce concours pour lui demander de clarifier la qualification attendue de la scène de ce poème, que son collectif percevait non pas comme une scène de séduction, mais comme une scène de viol. Cette lettre a déclenché une controverse dans le monde académique, qui a pris de l’ampleur du fait notamment de sa diffusion dans les réseaux sociaux.
                                <br/>Le 25 novembre 2024, à l’occasion de la journée internationale de la lutte contre les violences faites aux femmes, Madame Gaber a diffusé, sur les réseaux sociaux, le hashtag <i>#cheniercultureduviol</i>, qui est rapidement devenu viral.
                                <br/>M. André Chénier a alors été pris à partie sur X, Instagram et Facebook, où ont été publiés des milliers de messages anonymes à caractère injurieux. Le 1er décembre 2024, M. André Chénier a déposé une plainte en diffamation avec constitution de partie civile auprès du procureur de la république.
                                
                                <br/><br/>Lors de l’audience, Madame Gaber a reconnu être l’autrice de ce hashtag, assumant avoir de ce fait porté atteinte à l’honneur et à la réputation de M. Chénier, non par malveillance toutefois mais parce qu’elle considérait que ce poème – qui met en scène un berger et une bergère - était représentatif de la culture de viol, et qu’il était de sa responsabilité de future enseignante et de citoyenne de mettre cette question dans le débat public. Madame Gaber a affirmé qu’elle ne souhaitait pas « censurer » les œuvres problématiques du point de vue de la culture du viol, mais réfléchir aux conditions de leur transmission.
                                
                                <br/><br/>Son avocate a alors produit une vidéo représentant le poème, joué dans deux versions, toutes deux compatibles avec le texte de celui-ci. La première version dépeignait la scène comme un jeu amoureux consenti entre le berger et la bergère, en dépit des refus explicites de la bergère. La seconde version montrait un forçage de plus en plus explicite, jusqu’au viol. Pour l’avocate de Madame Gaber, la première scène est tout aussi problématique que la seconde, parce qu’elle suppose que les spectateurs adhèrent au cliché sexiste selon lequel “quand une femme dit non, elle pense oui”. C’est bien en cela que la culture du viol est problématique : parce qu’elle véhicule des représentations qui ont ensuite des conséquences dans le réel, comme les chiffres des violences sexistes et sexuelles le prouvent.
                                
                                <br/><br/>M. Chénier a pour sa part fait valoir la séparation de l’homme et de l’artiste, la fiction du réel, se déclarant en faveur de la liberté – totale – de création artistique.

                                </p>

                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>

            {/** Experte 1*/}
            <Dialog open={openExperte1} onClose={setOpenExperte1} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen ">
                    <div className="flex min-h-[90%] items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-y-auto rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <DialogTitle><h2 className="text-lg font-bold mb-5">Expertise de Hélène Merlin-Kajman</h2></DialogTitle>
                            <div className="overflow-y-auto"  style={{ maxHeight: "85vh"}}>
                                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                    <button
                                        type="button"
                                        onClick={() => setOpenExperte1(false)}
                                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon aria-hidden="true" className="size-6" />
                                    </button>
                                </div>
                                <p className="text-sm">
                                    <b>Professeure émérite de littérature à l’université Sorbonne Nouvelle, autrice de : <i> La littérature à l'heure de #Metoo</i>. (Ithaque 2020). </b>
                                    <br/><br/>
                                    Je rappelle que « L’Oaristys » est une idylle grecque du IIIe siècle avant J.C. traduite librement en 1780 par Chénier à 18 ans. C’est un dialogue fictif entre un berger et une bergère. Le berger presse la bergère de l’épouser et de faire l’amour avec lui. Elle dit « non » à répétition, mais se rend à certains arguments, ce qui permet au dialogue de se poursuivre. Pour finir, ils font l’amour ensemble, mais sans qu’elle ait cessé de dire « non », même si ce « non » s’est déplacé au cours du débat. 
                                    <br/><br/>Certes, le texte comprend des indices du désir de la bergère et même d’une forme d’acquiescement. Je confirme ce que disait M. Chénier tout à l’heure, “je me meurs” veut couramment dire au XVIIIe siècle “je me pâme de plaisir”, c’est “la petite mort”, si vous voulez. Mais la dissymétrie est criante. Dans la mesure où le jeu érotique repose sur une forme de forçage, il me paraît clair que le poème entretient une connivence avec la culture du viol. À la lecture, bien des lecteurs peuvent conclure : « c’est un viol ». 
                                    <br/><br/>Mais aurait-on pu le dire au XVIIIe siècle ? 
                                    <br/><br/>Sous l’Ancien Régime, le regard porté sur les femmes change (et d’abord, parce qu’elles commencent à participer activement à la construction de ce regard). Elles ne sont plus exclusivement cantonnées dans l’espace domestique, ni exclusivement assujetties aux hommes (père ou mari). Et on commence à prendre conscience de ce que nous appelons aujourd’hui la zone grise. Mais évidemment, dans le langage de l’époque. Et pour comprendre ce langage, il faut avoir en mémoire comment s’organise la sexualité sous l’Ancien Régime. La société repose sur un contrôle étroit des femmes. Ce qui leur est prescrit, c’est la virginité jusqu’au mariage, et la chasteté après. Car la sexualité est le critère exclusif de leur honneur, au point que même le viol les déshonore. Un interdit majeur pèse sur leur désir. Elles doivent empêcher les hommes de les approcher, sauf leur mari bien sûr. On pourrait même penser que la société les voudrait frigides : il faut qu’elles aient peur de la sexualité. En vertu du code de l’honneur et de la vertu chrétienne, elles sont programmées pour dire « non ». 
                                    <br/><br/>Mais ce non absolu peut être contourné par un jeu érotique relativement codé. “Relativement”: c’est tout le problème. D’autres signes peuvent en effet accompagner le « non », jusqu’à lui faire signifier « oui ». Et les hommes trouvent plus de plaisir à ce « non-oui » des femmes qu’à un « oui » clair et net. Quant aux femmes, elles ont une pudeur incorporée qui peut aller jusqu’à la paralysie. Elles n’ont donc accès à leur désir que dans ce langage du « non-oui » : elles ne peuvent pas dire « oui » sauf en passant par le « non ». 
                                    <br/><br/>Autrement dit, la résistance des femmes fait partie du scénario du « oui ». Le « non » est érotisé. D’où les métaphores de la conquête où les femmes sont conquises et les hommes conquérants. Une zone d’opacité et d’équivocité accompagne la séduction amoureuse, sans qu’on puisse à tout coup l’inscrire dans la culture du viol. 
                                    <br/><br/>Fort heureusement, cette grammaire a changé au fil du temps. Mais elle a changé lentement. D’où l’intérêt de se pencher aujourd’hui sur « L’Oaristys ». 
                                    <br/><br/>Je le rappelle, le poème est déjà anachronique au XVIIIe siècle. Par exemple, personne, ne croit alors ni en Diane ni en Vénus. 
                                    <br/><br/>De même, les bergers sont parfaitement imaginaires. Les lecteurs savent bien qu’ils ne vont pas les rencontrer dans la campagne. Ce qui leur arrive est stylisé et ne peut pas arriver “dans la vraie vie”. 
                                    <br/><br/>« L’Oaristys » n’est pas fait pour être cru. Certes, il y a un passage un peu réaliste : les questions de Naïs sur le statut social de Daphnis. Entre parenthèses, si viol il y a... il ne peut pas commencer à ce moment-là, contrairement à ce que montre la vidéo. Mais à part ce passage, on est dans un univers bucolique, mythologique et même symbolique, qui demande à être déchiffré. Je reprends l’exemple de Diane et Vénus. Diane est une déesse vierge qui incarne l’horreur de la sexualité. Vénus incarne la violence de la libido qui saisit chacun. La bergère se place sous le signe de Diane ; le berger se fait le porte-parole de Vénus. La bergère redoute son père. Le berger ne veut pas attendre l’autorisation des pères. Il incarne une certaine idée, dite « païenne », des pulsions sexuelles. Le poème refuse l’idée chrétienne du « péché de la chair ». Il se prononce pour une forme de liberté sauvage contre les normes sociales de la vertu et de l’honneur. Aucune réprobation morale ne pèse sur Naïs, qui a pourtant perdu sa virginité sans s’être défendue selon les canons des scènes de viol - je dis bien des scènes de viol : griffer, lutter, voire tuer (ou se tuer). Pour l’époque, elle devrait être inexcusable.
                                    <br/><br/>Maintenant, la lecture de ce poème risque-t-elle de conforter la culture du viol ? La réponse dépend de la façon dont on définit la littérature. Longtemps elle a été considérée sous l’angle privilégié de l’instruction morale. On peut certes, à partir d’une définition très normative de la littérature, ne voir dans « L’Oaristys » que la représentation d’un viol qui ne se dit pas. Mais on peut aussi considérer qu’un texte littéraire peut faire naître des scénarios fantasmatiques dans lesquels la perception de soi-même est flottante. Selon cette hypothèse, le passage à l’acte n’est pas du tout l’horizon de la lecture, ce qui invite à ne pas toujours envisager la littérature sous l’angle du réalisme, contrairement à ce que font les deux vidéos. « L’Oaristys » peut alors être lu, non pas comme la représentation condamnable d’un viol, mais comme une sorte de rêve. 
                                    <br/><br/>Je conclus. À ma génération, c’est-à-dire avant Mai 68 et la « libération sexuelle », l’interdit multiséculaire pesant sur la sexualité féminine était encore puissant. Même les lectures des jeunes filles étaient encore surveillées. Un poème comme « L’Oaristys » ne devait pas tomber entre leurs mains parce qu’il pouvait les inciter à « fauter ». 
                                    <br/><br/>Et aujourd’hui ? Même si la sexualité n’est plus un tabou, cet interdit existe encore. D’où l’intérêt pédagogique d’un tel texte à mes yeux. Il permet d’amorcer des débats d’interprétation avec les élèves sans façonner autoritairement leurs attentes et leurs désirs. J’ai fini. 

                                </p>

                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>

            {/** Experte 2*/}
            <Dialog open={openExperte2} onClose={setOpenExperte2} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="overscroll-contain fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen ">
                    <div className="flex min-h-[90%] items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-y-auto rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <DialogTitle><h2 className="text-lg font-bold mb-5">Expertise de Laure Murat</h2></DialogTitle>
                            <div className="overflow-y-auto"  style={{ maxHeight: "85vh"}}>
                                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                    <button
                                        type="button"
                                        onClick={() => setOpenExperte2(false)}
                                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon aria-hidden="true" className="size-6" />
                                    </button>
                                </div>
                                <p className="text-sm">
                                    <b>Professeure d’histoire à l’université de Californie, autrice de : <i>Une révolution sexuelle ? Réflexions sur l'après-Weinstein</i> (Stock, 2018) et de : <i>Qui annule quoi ? Sur la cancel culture</i> (Libelle Seuil, 2022).</b>
                                    <br/><br/>
                                    À la question de savoir si « L’Oaristys » d’André Chénier met en scène un viol, ma réponse sera double. 
                                    <br/><br/>Ma première réponse est : je ne sais pas. Elle dépend d’un contexte, soit l’ensemble des circonstances où un phénomène apparaît. N’étant pas spécialiste de la pastorale au XVIIIe siècle, maîtrisant mal les conventions littéraires du genre et de l’époque, je ne m’avancerai pas à décréter « c’est un viol », déclaration qui aurait pour effet de verrouiller le sens d’un poème qui joue, comme tant d’autres dans la littérature mondiale, sur l’ambiguïté. 
                                    <br/><br/>Néanmoins, comment se fait-il que je ne peux pas affirmer non plus : « ceci n’est pas un viol » ? 
                                    <br/><br/>Parce que la seconde réponse, que je vais développer ici, se situe ailleurs, dans un déplacement de la question : ce texte, comme tant d’autres, relève sans aucune ambigüité cette fois, de la « culture du viol » – et je vais m’expliquer sur ce terme. Cette deuxième réponse dépend d’une autre dimension de la lecture d’un texte, remis dans son contexte, et analysé dans sa réception et dans ses effets. Un texte antisémite était un texte « banal » dans les années 1930. On ne peut pas, et on ne doit pas, le lire de la même façon après l’Holocauste, comme si l’Holocauste n’avait jamais existé. C’est pourquoi je crois très important de préserver les textes dans toute leur intégrité (sans en changer un mot, même si celui-ci est choquant pour nos oreilles contemporaines), car ces “falsifications » reviendraient à priver les opprimés de l’histoire patiente et cumulative de leur oppression. 
                                    <br/><br/>Le problème central est celui de la valence de la « culture du viol ». L’expression a été forgée dans les années 1970 par la sociologie féministe américaine, pour désigner un ensemble de comportements stéréotypés dans la société qui minimisent, excusent, banalisent voire encouragent et érotisent le viol, sur le mode « elle dit non, mais elle pense oui » – ce qui correspond très exactement au propos de « L’Oarystis ». 
                                    <br/><br/>Cette culture du viol, est fondée sur un verbe à double sens : ravir, c’est-à-dire à la fois enlever et satisfaire, si bien que l’attentat se confond toujours avec le plaisir – le ravissement – supposé. Cette culture est profondément ancrée dans les mœurs : « elle l’a bien cherché », « elle l’a provoqué », « elle voulait une promotion », sont des expressions qu’on entend en boucle à chaque nouvelle affaire. En 2022, un sondage en France a montré que 23% des hommes entre 18 et 24 ans pensent que « beaucoup de femmes prennent plaisir à être forcée ». 
                                    <br/><br/>Or ces croyances ont été largement légitimées par un corpus d'œuvres immense, allant de la poésie savante à la presse populaire, de la peinture au cinéma, depuis la mythologie grecque et la Bible. Alors, est-ce un anachronisme, que d’appliquer un terme (la culture du viol) à une époque où il n’est ni inventé, ni théorisé ? Je ne crois pas. Ce n’est pas parce que l’inconscient a été inventé autour de 1900 par Freud que Louis XIV n’avait pas d’inconscient. Autrement dit, si je dis que la scène est caractéristique de la « culture du viol », je produis peut-être un anachronisme mais il a du sens. Et il a d’autant plus de sens si on se penche sur l’histoire des représentations. 
                                    <br/><br/>« L’art d’Occident [je cite] ne sait parler de sexe que sur un seul mode : la violence. Il vaudrait mieux dire le viol. L’obsession sexuelle de l’art occidental, c’est le viol. Traque, rapt, coït, avec usage de la force (...) On dira sans doute que l’on exagère. À tort. C’est que l’habitude nous rend aveugles.[3] » (fin de citation). Cette citation n’est pas tirée d’un tract féministe et militant. Elle est due à Régis Michel, conservateur en chef au musée du Louvre, dans le catalogue d’une exposition qui a eu lieu en 2000, intitulée Posséder et détruire. Je ne sais pas ce que Régis Michel savait de la culture du viol, il y a 25 ans. Sans doute pas grand-chose. Pourtant, son constat est sans appel, sur des œuvres pourtant difficiles à interpréter : comment conclure à un viol sur une peinture, un dessin, soit une image fixe ? En grand spécialiste de l’art des XVIIIe et XIXe siècle, il « lit », il « interprète », ce qui pour lui relève de l’évidence : la prédation, la violence, le viol. 
                                    <br/><br/>Je répète : dire de « L’Oaristys » « c’est un viol », ex abrupto, verrouille le sens. Mais dire, « ce n’est pas un viol », l’escamote. En revanche, expliquer en quoi ce poème relève de la culture du viol, ouvre le sens. L’euphémisation du viol, qui consiste à ériger l’ambiguïté du consentement ou de la résistance en principe de plaisir, est un fléau de notre culture, d’hier à aujourd’hui. C’est le cas dans les Liaisons Dangereuses. C’est le cas dans la série Game of Thrones, où il n’y pas un épisode sans viol (ou à peu près). Le viol est, reste, un poncif. 
                                    <br/><br/>Que des agrégatifs, c’est-à-dire de jeunes enseignants destinés à former des élèves de collège, s’interrogent sur le sens de l’Oarystis, à l’heure d’une surexposition banalisée aux images de violences sexuelles, me semble salutaire. L’histoire des représentations en matière de sexualité a privilégié depuis la nuit des temps la « zone grise », cette zone indécise qui d’un côté, condamne officiellement, juridiquement, le viol, figuré comme un crime – c’est le cas dans la pastorale –, isolé comme une exception, mais de l’autre, met en scène discrètement ses attributs en scène, en faisant monter la tension, en l’esthétisant, comme mode d’excitation. L’érotisation du viol est un obstacle majeur – et très efficace – à sa lecture en tant que crime. Crime constamment dénié, contourné, éludé, jusque dans la fameuse tribune Deneuve, première réaction française officielle contre le mouvement #MeToo publiée par Le Monde, qui s’ouvrait sur cet incipit désormais célèbre : « Le viol est crime. Mais...». Il n’y a pas de mais. 

                                </p>

                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>

        </>
    )
}
